/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Compare_NewslettersInputs */

const en_why_listening_compare_newsletters = /** @type {(inputs: Why_Listening_Compare_NewslettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Newsletters and emails`)
};

const es_why_listening_compare_newsletters = /** @type {(inputs: Why_Listening_Compare_NewslettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Newsletters y correos`)
};

/**
* | output |
* | --- |
* | "Newsletters and emails" |
*
* @param {Why_Listening_Compare_NewslettersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_compare_newsletters = /** @type {((inputs?: Why_Listening_Compare_NewslettersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Compare_NewslettersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_compare_newsletters(inputs)
	return en_why_listening_compare_newsletters(inputs)
});